import request from '../index'

/**
 * 获取VIP商品列表
 * @param {*} query
 * @returns
 */
export function getVipShopList(query) {
    return request({
        url: '/box/member/goodsList',
        method: 'get',
        params: query
    })
}

/**
 * 获取支付配置信息
 * @param {*} query
 * @returns
 */
export function getPayConfig(query) {
    return request({
        url: '/order/paymentBusinessConfig',
        method: 'get',
        params: query
    })
}
